import React from 'react';
import './CustomIcon.scss';

type ImageProps = React.HTMLAttributes<HTMLImageElement>;
type SVGProps = React.SVGProps<SVGSVGElement>;

export type CustomIconProps = {
    src: string | React.FC<SVGProps>;
    alt: string;
} & (ImageProps | SVGProps);

export const CustomIcon: React.FC<CustomIconProps> = ({ src, alt, className, ...props }) => {
    if (typeof src === 'string') {
        return <img src={src} alt={alt} className={`custom-icon ${className}`} {...(props as ImageProps)} />;
    }

    const IconComponent = src;
    return <IconComponent className={`custom-icon ${className}`} {...(props as SVGProps)} />;
};
